import React, { useMemo } from "react";
import { Form } from "react-bootstrap";
import Select, { components } from "react-select";
import { FiGlobe } from "react-icons/fi";

export function DirectionIcon({ size = 16 }) {
    return <FiGlobe size={size} color="#64748b" />;
}

function buildOption(item) {
    const country = item.country_code || {};
    const callingCode = country.calling_code ? `+${country.calling_code}` : "";
    return {
        value: item.id,
        countryName: country.name,
        callingCode,
        isEnabled: item.is_enabled !== false,
        label: `${country.name || "Unknown"} ${callingCode}`,
    };
}

const OptionRow = (props) => (
    <components.Option {...props}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <DirectionIcon />
            <span>{props.data.label}</span>
            {!props.data.isEnabled && (
                <span style={{ marginLeft: "auto", fontSize: 11, color: "#9ca3af" }}>
                    Disabled
                </span>
            )}
        </div>
    </components.Option>
);

const MultiValueLabelRow = (props) => (
    <components.MultiValueLabel {...props}>
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
            <DirectionIcon />
            {props.data.label}
        </span>
    </components.MultiValueLabel>
);

const CountryCodeDirectionPicker = ({
    items = [],
    selectedIds = [],
    onChange,
    placeholder = "Select Country Codes",
    isDisabled = false,
    label = "Country Codes:",
    required = false,
    groupClassName = "col-md-6 form-group",
    iconWrap = false,
}) => {
    const options = useMemo(
        () => items.filter((i) => i.is_enabled !== false).map(buildOption),
        [items]
    );

    const value = useMemo(
        () => options.filter((opt) => selectedIds.includes(opt.value)),
        [options, selectedIds]
    );

    const selectEl = (
        <Select
            className={`theme-react-select${iconWrap ? " ccf-select-in-icon" : ""}`}
            classNamePrefix="theme-react-select"
            isMulti
            isDisabled={isDisabled}
            options={options}
            value={value}
            onChange={(selected) =>
                onChange((selected || []).map((opt) => opt.value))
            }
            placeholder={placeholder}
            components={{
                Option: OptionRow,
                MultiValueLabel: MultiValueLabelRow,
            }}
        />
    );

    return (
        <Form.Group className={groupClassName}>
            <Form.Label>
                {label}
                {required && <span className="text-danger ms-1">*</span>}
            </Form.Label>
            {iconWrap ? (
                <div className="ccf-input-with-icon">
                    <span className="ccf-input-with-icon__icon">
                        <FiGlobe size={18} />
                    </span>
                    {selectEl}
                </div>
            ) : (
                selectEl
            )}
        </Form.Group>
    );
};

export default CountryCodeDirectionPicker;
